module.exports = __webpack_public_path__ + "static/media/progress-prototype.c0507a40.gif";